import { QUERIES } from '@repo/ui/queries';
import styled from 'styled-components';

import { CenterChildren } from 'styles/layouts';

export const ImageRow = styled(CenterChildren)`
  width: 100%;
  flex-wrap: wrap;
  gap: 48px;

  ${QUERIES.largeTabletAndUp} {
    gap: 72px;
  }
`;
